import React from 'react';
import PropTypes from 'prop-types';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import BlockButton from './BlockButton';
import BlockBanner from './BlockBanner';

const Block = ({ username, url, reasoncode, reason }) => (
  <Container as="main" className="main">
    <BlockBanner />
    <Container className="pt-4 pb-4">
      <Row className="justify-content-center">
        <div className="col-lg-8">
          <h2>Website Blocked</h2>
          <p>
            {username === '' ? '' : 'Hi'}
            <strong className="text-capitalize">{username}</strong>This website is blocked to help protect Doma employees from malicious and
            suspicious internet content.
          </p>
          <p>
            You tried to visit <strong>{url}</strong>, which was blocked by security policy: <strong>{reasoncode}</strong>
          </p>
          <strong>Reason:</strong>
          <p>{reason}</p>
          <p>
            If you believe this is not correct, or you have a valid business justification to access this website, please click on{' '}
            <strong>Open a Service Request</strong> below to send a service ticket to Information Security.
          </p>
          <p>
            Click <strong>Read Technology Acceptable Use Policy</strong> to learn more about our policies.
          </p>
          <p>
            For any questions, concerns, or to report suspicious activity, please email{' '}
            <a href="mailto:informationsecurity@doma.com"> InformationSecurity@doma.com.</a>
          </p>
        </div>
      </Row>
    </Container>
    <BlockButton
      url={url}
      reasoncode={reasoncode}
      reason={reason}
      redirect={`mailto:InformationSecurity@doma.com?subject=Zscaler:%20Allow%20${reasoncode}&body=Please%20Allow%20Web-Application:%20${url}%0D%0ABlock%20Reason:%20${reason}%0D%0ABusiness%20Justification:%20Enter%20the%20reason%20here`}
    />
  </Container>
);

Block.propTypes = {
  username: PropTypes.string,
  category: PropTypes.string,
  url: PropTypes.string,
  reasoncode: PropTypes.string,
  reason: PropTypes.string,
};

export default Block;
